import { InsertDriveFile } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import { getToken } from "../../../services/auth.service";
import { getDocuments } from "../../../services/documents.service";
import { getAllEvents } from "../../../services/event.service";
import { getUserOnly } from "../../../services/expositor/subscriptions.service";
import { parseDate } from "../../../utils/parseDate";

export const getReceipts = async () => {
  return await (
    await fetch(`${process.env.REACT_APP_API_URL}/receipts`)
  ).json();
};

export const deleteReceipt = async (id) => {
  return await (
    await fetch(`${process.env.REACT_APP_API_URL}/receipts/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
  ).json();
};

export default function Documents() {
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [documents, setDocuments] = React.useState([]);
  const [receipts, setReceipts] = React.useState([]);
  const [subscriptions, setSubscriptions] = React.useState([]);
  const [events, setEvents] = React.useState([]);
  const [selectedEventId, setSelectedEventId] = React.useState<number | null>(
    null
  );
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const cols = isLgUp ? 5 : isMdUp ? 4 : isSmUp ? 3 : 2;

  React.useEffect(() => {
    getUserOnly().then((data) => {
      setSubscriptions(data);
    });
  }, []);

  React.useEffect(() => {
    getDocuments().then((data) => {
      setDocuments(data);
    });
  }, []);

  React.useEffect(() => {
    getReceipts().then((data) => {
      setReceipts(data);
    });
  }, []);

  React.useEffect(() => {
    getAllEvents().then((data) => {
      setEvents(data);
      console.log(data, documents, subscriptions);
    });
  }, []);

  const eventsFromUser = new Set([...subscriptions.map((s) => s.event_id)]);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  // Define evento selecionado automaticamente e mantém consistente com eventos do usuário
  React.useEffect(() => {
    const userEventsList = events.filter((e) => eventsFromUser.has(e.id));
    if (!selectedEventId && userEventsList.length > 0) {
      setSelectedEventId(userEventsList[0].id);
    }
    if (
      selectedEventId &&
      !userEventsList.find((e) => e.id === selectedEventId)
    ) {
      setSelectedEventId(userEventsList.length ? userEventsList[0].id : null);
    }
  }, [events, subscriptions, selectedEventId]);

  const userEvents = events.filter((event) => eventsFromUser.has(event.id));

  return (
    <Paper
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 3,
        border: "1px solid #e2e8f0",
        boxShadow:
          "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        backgroundColor: "#ffffff",
      }}
    >
      {userEvents.length > 0 ? (
        <>
          <Tabs
            value={selectedEventId}
            onChange={(e, val) => setSelectedEventId(val)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ mb: 2, borderBottom: "1px solid #e2e8f0" }}
          >
            {userEvents.map((ev) => (
              <Tab
                key={ev.id}
                value={ev.id}
                label={`${ev.name} - ${parseDate(ev.starts_at)}`}
                sx={{ textTransform: "none", fontWeight: 600 }}
              />
            ))}
          </Tabs>

          <Typography
            sx={{
              display: "inline-block",
              fontSize: "0.9rem",
              mb: 2,
              background: "#f1f5f9",
              border: "1px solid #e2e8f0",
              borderRadius: "9999px",
              color: "#64748b",
              px: 2,
              py: 0.5,
            }}
          >
            Documentos
          </Typography>

          {(() => {
            const docsForSelected = documents.filter((doc) =>
              selectedEventId ? doc.event_id === selectedEventId : false
            );
            return docsForSelected.length > 0 ? (
              <ImageList cols={cols} gap={12} sx={{ m: 0 }}>
                {docsForSelected.map((item) => (
                  <a
                    key={item.id}
                    target={"_blank"}
                    rel="noreferrer"
                    href={item.url}
                  >
                    <ImageListItem
                      sx={{
                        borderRadius: 2,
                        overflow: "hidden",
                        border: "1px solid #e2e8f0",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                        transition:
                          "transform 0.15s ease, box-shadow 0.2s ease",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 8px 20px rgba(36,50,77,0.25)",
                        },
                      }}
                    >
                      <img
                        src={
                          item.file_type.includes("image/")
                            ? item.url
                            : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAbFBMVEX///8AAABLS0vc3NwwMDDo6Oi0tLTCwsJ0dHSGhoY9PT0/Pz/09PQcHBx4eHg4ODhVVVUUFBTIyMiXl5eqqqqhoaFtbW3S0tLOzs4uLi7i4uJlZWUlJSVfX19QUFCsrKwYGBiAgIBFRUW6urrFevtnAAADDElEQVR4nO3d61IaQRRF4eGiEMMtQAA..."
                        }
                        alt={item.title}
                        loading="lazy"
                        style={{
                          width: "100%",
                          height: 180,
                          objectFit: "cover",
                          background: "#f8fafc",
                        }}
                      />
                      <ImageListItemBar
                        title={item.name}
                        subtitle={item["file_type"]}
                        sx={{
                          background:
                            "linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0.15))",
                          ".MuiImageListItemBar-title": { fontWeight: 600 },
                          ".MuiImageListItemBar-subtitle": { opacity: 0.85 },
                        }}
                      />
                    </ImageListItem>
                  </a>
                ))}
              </ImageList>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  border: "1px dashed #e2e8f0",
                  borderRadius: 2,
                  p: 3,
                  bgcolor: "#f8fafc",
                  color: "#64748b",
                }}
              >
                <InsertDriveFile
                  sx={{
                    fontSize: 48,
                    color: theme.palette.primary.main,
                    mb: 1,
                  }}
                />
                <Typography sx={{ fontWeight: 600 }}>
                  Nenhum documento encontrado para este evento
                </Typography>
                <Typography variant="body2">
                  Quando houver documentos disponíveis, eles aparecerão aqui.
                </Typography>
              </Box>
            );
          })()}
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            border: "1px dashed #e2e8f0",
            borderRadius: 2,
            p: 3,
            bgcolor: "#f8fafc",
            color: "#64748b",
          }}
        >
          <InsertDriveFile
            sx={{ fontSize: 48, color: theme.palette.primary.main, mb: 1 }}
          />
          <Typography sx={{ fontWeight: 600 }}>
            Nenhum evento encontrado
          </Typography>
          <Typography variant="body2">
            Você ainda não possui eventos associados.
          </Typography>
        </Box>
      )}
      {false &&
        events &&
        events
          .filter((event) => eventsFromUser.has(event.id))
          .map((event) => (
            <Accordion
              key={event.id}
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
              sx={{
                mb: 2,
                borderRadius: 2,
                border: "1px solid #e2e8f0",
                boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                sx={{
                  px: { xs: 2, sm: 3 },
                  py: { xs: 1, sm: 1.5 },
                  backgroundColor: "#f1f5f9",
                  "&:hover": { backgroundColor: "#e2e8f0" },
                }}
              >
                <div>
                  <Typography
                    sx={{
                      width: { xs: "100%", sm: "33%" },
                      flexShrink: 0,
                      fontWeight: 600,
                      color: "#24324D",
                    }}
                  >
                    {event.name}
                  </Typography>
                  <Typography sx={{ color: "#64748b" }}>{`${parseDate(
                    event.starts_at
                  )} ate ${parseDate(event.ends_at)}`}</Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  sx={{
                    display: "inline-block",
                    fontSize: "0.9rem",
                    mb: 2,
                    background: "#f1f5f9",
                    border: "1px solid #e2e8f0",
                    borderRadius: "9999px",
                    color: "#64748b",
                    px: 2,
                    py: 0.5,
                  }}
                >
                  Documentos
                </Typography>
                <ImageList cols={cols} gap={12} sx={{ m: 0 }}>
                  {documents &&
                    documents
                      .filter((doc) => doc.event_id === event.id)
                      .map((item) => (
                        <a
                          key={item.id}
                          target={"_blank"}
                          rel="noreferrer"
                          href={item.url}
                        >
                          <ImageListItem
                            sx={{
                              borderRadius: 2,
                              overflow: "hidden",
                              border: "1px solid #e2e8f0",
                              boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                              transition:
                                "transform 0.15s ease, box-shadow 0.2s ease",
                              "&:hover": {
                                transform: "translateY(-2px)",
                                boxShadow: "0 8px 20px rgba(36,50,77,0.25)",
                              },
                            }}
                          >
                            <img
                              src={
                                item.file_type.includes("image/")
                                  ? item.url
                                  : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAbFBMVEX///8AAABLS0vc3NwwMDDo6Oi0tLTCwsJ0dHSGhoY9PT0/Pz/09PQcHBx4eHg4ODhVVVUUFBTIyMiXl5eqqqqhoaFtbW3S0tLOzs4uLi7i4uJlZWUlJSVfX19QUFCsrKwYGBiAgIBFRUW6urrFevtnAAADDElEQVR4nO3d61IaQRRF4eGiEMMtQAAxaozv/46JSf50M1xK9j5ntNb3ANOs6p7pES27aQAAAAAAAAAAAD685WrWnw9F7vvZObXlQ0/sLjupsP6m7utW4n5o6OtS4ndP3x9fs9P+2dgCO5K4MAZ2ItE5g2/S70XfPdiRxIE9MHuhmraJ7iTeRgSmJv6IKcxLHAUF5iU+1h/k6XV7c51jz+akxOpTTLfXX/LonZ2SuKs+xERwzePProx9sVpRghk8+XROSBwXH+BJcs1T+0/8Qn0qxn+WXPPkDhs+i339Ij3zDhE9i2XhQHLNM29JwbOYUBg8ixmFsbPoLxzPc2fRX/ilafmWMnAWIwonLT++xCVGFDaTzFkMKWwm07zEmMLWxKDHTVBh4ixGFebNYlhhM/mZM4txhVkLNbCwddOYS0Y8JbKwdRbtiaGFKVt/bGHGvRhcmDCL0YXxm0Z4YXhifGHT3Icm+gvvZuPS7OBXJdbElO9p2tj2xc4U9oaSsQ91p9C1UDtU2HuUjF7rUqHnbzUpfA8KKdSi8D0opFDLUXgzutT6gxZebv/pCwcUClDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaEChV4UKlDoRaHC5y8sT3jcWcY4rjwFVXOCZq08N35tGeO48j9DLixjvASsk+N+FaO/WMaozpKNXabVUb2eFbQtB5GcB3ypSTW25hTUA9UoijOdL7SrD2QxjfNQDdNbXH0u9yW2t/164I2pcFkPlMb2DGg5EyWF63yLpnnNTvtvZCtsWs56TeA8KXBwfvgAe2NhveunML8vbrL7ejNvYP3+Hc9zwkwhdxbH/sDcezHoZ7ZB1s4/tz5FC+uWowntps9hfW9GB6/hZptlaN9fy9WsPx/6zfuzVfS3QgAAAAAAAAAAAAa/ARXQN87ZDmHrAAAAAElFTkSuQmCC"
                              }
                              alt={item.title}
                              loading="lazy"
                              style={{
                                width: "100%",
                                height: 180,
                                objectFit: "cover",
                                background: "#f8fafc",
                              }}
                            />
                            <ImageListItemBar
                              title={item.name}
                              subtitle={item["file_type"]}
                              sx={{
                                background:
                                  "linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0.15))",

                                ".MuiImageListItemBar-title": {
                                  fontWeight: 600,
                                },
                                ".MuiImageListItemBar-subtitle": {
                                  opacity: 0.85,
                                },
                              }}
                            />
                          </ImageListItem>
                        </a>
                      ))}
                </ImageList>
              </AccordionDetails>
            </Accordion>
          ))}
    </Paper>
  );
}
